import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Model, useValue } from '@morningtrain/react-resources'
import { Currency } from 'support/displays'
import SaveOrderAsDraft from 'support/actions/inventory/SaveOrderAsDraft'
import CompleteOrder from 'support/actions/inventory/CompleteOrder'
import { ButtonWrap } from 'ui/layouts'
import ReceiveOrder from 'support/actions/inventory/ReceiveOrder'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import WhenOrderIsDeliveryNote from 'pages/app/inventory/order/partials/WhenOrderIsDeliveryNote'
import ReopenOrder from 'support/actions/inventory/ReopenOrder'
import HandleOrder from 'support/actions/inventory/HandleOrder'

function InventoryOrderSmartviewFooter (props) {
  const [orderItems] = useEnvValue('globals.inventory.order_items')

  const [summedTotalPrice, setSummedTotalPrice] = React.useState(0)
  const [summedReceivedPrice, setSummedReceivedPrice] = React.useState(0)
  const [summedOffsetPrice, setSummedOffsetPrice] = React.useState(0)
  const [minOrderPrice] = useEnvValue('globals.inventory.minimum_order_price', 0)
  const [errorMinOrderPrice, setErrorMinOrderPrice] = useEnvValue('globals.inventory.error_min_order_price', false)

  React.useEffect(() => {
    let totalSum = 0
    let receivedSum = 0
    let offsetSum = 0

    const orderItemsArray = Object.values(orderItems)

    if (orderItemsArray && orderItemsArray.length > 0) {
      orderItemsArray.forEach(orderItem => {
        if (orderItem.total_price) {
          totalSum += orderItem.total_price
        }
        if (orderItem.received_price) {
          receivedSum += orderItem.received_price
        }
        if (orderItem.received_offset_price) {
          offsetSum += orderItem.received_offset_price
        }
      })
    }

    if (isNaN(totalSum)) {
      totalSum = 0
    }

    if (isNaN(offsetSum)) {
      offsetSum = 0
    }

    if (isNaN(receivedSum)) {
      receivedSum = 0
    }

    setSummedTotalPrice(totalSum)
    setSummedReceivedPrice(receivedSum)
    setSummedOffsetPrice(offsetSum)
  }, [orderItems])

  React.useEffect(() => {
    const orderItemsArray = Object.values(orderItems)
    let totalQty = 0;
    if (orderItemsArray && orderItemsArray.length > 0) {
      orderItemsArray.forEach(orderItem => {
        if (orderItem.total > -1) {
          totalQty += orderItem.total
        }
      })
    }
    if (totalQty < 1) {
      setErrorMinOrderPrice(true)
      return
    }
    if (summedTotalPrice < minOrderPrice) {
      setErrorMinOrderPrice(minOrderPrice)
      return
    }
    setErrorMinOrderPrice(false)
  },[summedTotalPrice, orderItems])

  return (
    <>
      <SmartviewContentSeparator />
      <UI.SpaceBetween className={errorMinOrderPrice? '' : 'hidden'}>
        <UI.Text weight='light' color='red'>
          <Translation name='partials.minimum_order_price'/>
        </UI.Text>
        <UI.Text weight='light' color='red'>
          <Currency defaultValue={minOrderPrice} />
        </UI.Text>
      </UI.SpaceBetween>
      <UI.SpaceBetween>
        <UI.Text weight='medium'>
          <Translation name='partials.total_price' />
        </UI.Text>
        <UI.Text weight='medium'>
          <Currency defaultValue={summedTotalPrice} />
        </UI.Text>
      </UI.SpaceBetween>
      <WhenOrderIsDeliveryNote>
        <UI.SpaceBetween>
          <UI.Text weight='medium'>
            <Translation name='partials.total_received_price' />
          </UI.Text>
          <UI.Text weight='medium'>
            <Currency defaultValue={summedReceivedPrice} />
          </UI.Text>
        </UI.SpaceBetween>
        {summedOffsetPrice !== 0
          ? (
            <UI.SpaceBetween>
              <UI.Text weight='medium' color='red'>
                <Translation name='partials.total_received_offset_price' />
              </UI.Text>
              <UI.Text weight='medium' color='red'>
                <Currency defaultValue={summedOffsetPrice} />
              </UI.Text>
            </UI.SpaceBetween>
            )
          : null}
      </WhenOrderIsDeliveryNote>
      <SmartviewContentSeparator />
      <Model resourceName='inventory.order' operationName='read' clean autoFetch={false}>
        <ButtonWrap>
          <SaveOrderAsDraft />
          <CompleteOrder />
          <ReopenOrder />
          <HandleOrder />
          <ReceiveOrder />
        </ButtonWrap>
      </Model>
    </>
  )
}

export default InventoryOrderSmartviewFooter
